"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateComparison_1 = __importDefault(require("../Util/dateComparison"));
const PeriodNotFoundException_1 = __importDefault(require("../Exception/PeriodNotFoundException"));
class PeriodPicker {
    constructor(dateTimeProvider, dateTimeModifier) {
        this.pickPeriod = (periods, dateRange) => {
            const period = periods.find((p) => {
                return ((0, dateComparison_1.default)(this.dateTimeProvider.fromDateTimeToDate(p.startDate), this.dateTimeProvider.fromDateTimeToDate(dateRange.from)) !== 1 &&
                    (0, dateComparison_1.default)(this.dateTimeProvider.fromDateTimeToDate(p.endDate), this.dateTimeProvider.fromDateTimeToDate(dateRange.from)) !== -1);
            });
            if (period === undefined) {
                throw new PeriodNotFoundException_1.default(dateRange);
            }
            return period;
        };
        this.pickPeriods = (subscriptions, dateRange) => {
            return subscriptions
                .filter((s) => {
                return this.dateTimeModifier.dateIsSameOrAfter(this.dateTimeProvider.fromDateTimeToDate(s.endDate), dateRange.from);
            })
                .filter((s) => {
                return this.dateTimeModifier.dateIsSameOrAfter(dateRange.to, this.dateTimeProvider.fromDateTimeToDate(s.startDate));
            });
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
    }
}
exports.default = PeriodPicker;
//# sourceMappingURL=PeriodPicker.js.map